/* eslint-disable react/prop-types */
import React from 'react'
import {
    DataTable, TableContainer, Table, TableHead,
    TableRow, TableHeader, TableBody, TableCell, TableToolbar,
    TableToolbarContent, TableToolbarSearch, TableExpandRow, TableExpandedRow, TableExpandHeader
} from 'carbon-components-react'
import { Renew16 } from '@carbon/icons-react';
import TableToolbarDownload from 'common/TableToolbarDownload';
import i18n from "../../i18n";

const QualityCheckTable = (props) => {

    const Context = i18n.t('qualityCode.Context')
    const Alerts = i18n.t('qualityCode.Alerts')
    
    return (
        <DataTable size="tall" isSortable={true} rows={props.rows} headers={props.headers} render={({
            rows,
            headers,
            getHeaderProps,
            getRowProps,
            getTableProps,
            getBatchActionProps,
            onInputChange }) => (
            <TableContainer>
                <TableToolbar>
                    <TableToolbarContent>
                        <TableToolbarSearch
                            tabIndex={getBatchActionProps().shouldShowBatchActions ? -1 : 0}
                            onChange={onInputChange}
                        />
                        {props.showReload ?
                            <div className="reload">
                                <Renew16 onClick={props.getQualityCheckData} />
                            </div>
                            :
                            ''
                        }
                        {/* Rename file name of the exported file */}
                        <TableToolbarDownload iconDescription='Export' rows={props.fullRows} headers={props.headers} title={Alerts} filename="export" label="Download" />
                    </TableToolbarContent>
                </TableToolbar>
                <Table {...getTableProps()}>
                    <TableHead>
                        <TableRow>
                            {props.isExpandable && <TableExpandHeader />}
                            {headers.map(header => (
                                header.header && <TableHeader {...getHeaderProps({ header })}>
                                    {header.header}
                                </TableHeader>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, i) => (
                            props.isExpandable
                            ?
                            <React.Fragment key={row.id}>
                                <TableExpandRow {...getRowProps({ row })}>
                                {row.cells.map(cell => (
                                    cell.info.header !== 'content' && <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                </TableExpandRow>
                                {row.isExpanded && (
                                <TableExpandedRow colSpan={headers.length + 1}>
                                    <div className="carbon-display-Semibold-16">{Context}</div>
                                    <p className="carbon-display-Regular-12">{row.cells[5].value}</p>
                                </TableExpandedRow>
                                )}
                            </React.Fragment>
                            :
                            <TableRow key={"row" + i} {...getRowProps({ row })}>
                                {row.cells.map((cell, index) => (
                                    <TableCell key={"cell" + index + i}>
                                        {cell.value === 'Completed' ? <span className="completed-link" onClick={() => props.goToCompletedResult(row)}>{cell.value}</span> :cell.value || "-"}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>)}
        />
    );
}
export default QualityCheckTable
